import { SUB_MENU_PRODUCTS, SUB_MENU_RESOURCES } from 'pages/landing/v2/components/Header/constants';

export const MENU = [
    {
        title: 'Database',
        link: '/search'
    },
    {
        title: 'Feed',
        link: '#feed'
    },
    {
        title: 'Assessment',
        link: '#assessment'
    },
    {
        title: 'SDK',
        link: '#sdk'
    },
    SUB_MENU_PRODUCTS,
    SUB_MENU_RESOURCES,
    {
        title: 'Contacts',
        link: '/company/contacts'
    },
    {
        title: 'Pricing',
        link: '/price-list'
    }
];
